import api from "./client";
import logger from "../utils/logger";

/**
 * Create a custom offer in a conversation
 */
export async function createCustomOffer(payload) {
  try {
    const res = await api
      .apiPost("v1/custom-offers", payload)
      .catch(() => api.apiPost("custom-offers", payload));
    return res?.data?.data || res?.data || res;
  } catch (err) {
    logger.error("Failed to create custom offer", err);
    throw err;
  }
}

/**
 * Accept a custom offer
 */
export async function acceptCustomOffer(offerId) {
  if (!offerId) throw new Error("Missing custom offer ID");
  try {
    const res = await api
      .apiPost(`v1/custom-offers/${offerId}/accept`)
      .catch(() => api.apiPost(`custom-offers/${offerId}/accept`));
    return res?.data?.data || res?.data || res;
  } catch (err) {
    logger.error(`Failed to accept custom offer #${offerId}`, err);
    throw err;
  }
}

/**
 * Reject a custom offer
 */
export async function rejectCustomOffer(offerId) {
  if (!offerId) throw new Error("Missing custom offer ID");
  try {
    const res = await api
      .apiPost(`v1/custom-offers/${offerId}/reject`)
      .catch(() => api.apiPost(`custom-offers/${offerId}/reject`));
    return res?.data?.data || res?.data || res;
  } catch (err) {
    logger.error(`Failed to reject custom offer #${offerId}`, err);
    throw err;
  }
}
